
import {  GridApi,  GridOptions,  IServerSideDatasource,} from "@ag-grid-community/core";
import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from "@angular/core";
import { DateCellRendererComponent } from "src/app/ag-grid-components/date-cell-renderer/date-cell-renderer.component";
import { LoadingCellRendererComponent } from "src/app/ag-grid-components/loading-cell-renderer/loading-cell-renderer.component";
import { SkuCellRendererComponent } from "src/app/ag-grid-components/sku-cell-renderer/sku-cell-renderer.component";
import { HeaderService } from "src/app/components/header/header.service";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { PlanyardService } from "./../../../planyard/planyard.service";
import { HumanizeDatePipe } from "./../../../../pipes/humanize-date.pipe";

@Component({
  selector: "app-sku-fba-history-grid",
  templateUrl: "./sku-fba-history-grid.component.html",
  styleUrls: ["./sku-fba-history-grid.component.scss", "../mini-grid.scss"],
  providers: [HumanizeDatePipe],
})
export class SkuFbaHistoryGridComponent implements OnInit,OnChanges, OnDestroy {
  private destroy$ = new Subject<void>();
  _asin: string;
  get asin(): string {
    return this._asin;
  }
  @Input() set asin(value: string) {   
    this._asin= value;   
  }
  @Input() firstStockDate: string;
  @Input() title: string;
  @Input() account:string;
  gridApi: GridApi;
  _stockType: string;
  get stockType(): string {
    return this._asin;
  }
  @Input() set stockType(value: string) {   
    this._stockType= value;
   }
  columnDefs: any= [
    {
      field: "date",
      filter: "agDateColumnFilter",
      valueFormatter: (params) =>
        this.humanizeDatePipe.transform(params.value, "MM/dd/yyyy"),
      width: 90,
      maxWidth: 170,
    },
    {
      field:"qt",
      headerName: "Stock",
      width: 50,
      maxWidth: 80,
      valueGetter: (params) => {
        return (Number(params.data.qt) || 0).toLocaleString('en');
      }
    },
    {
      field: "aqty",
      headerName: "FBA Sales",
      width: 70,
      maxWidth: 70,
      valueGetter: (params) => {
        return (Number(params.data.aqty) || 0).toLocaleString('en');
      }
    },
    {
      field: "Abnormal",
      headerName: "Abnormal",
      width: 70,
      maxWidth: 70
    },
    {
      field: "mqty",
      headerName: "FBM Sales",
      width: 70,
      maxWidth: 70,
      valueGetter: (params) => {
        return (Number(params.data.mqty) || 0).toLocaleString('en');
      } 
    },
    {
      field: "Pushed",
      headerName: "Pushed ",
      width: 70,
      maxWidth: 70,
      valueGetter: (params) => {
        return (Number(params.data.Pushed) || 0).toLocaleString('en');
      }
    }
  ];

  components = {
    loadingCellRenderer: LoadingCellRendererComponent,
    dateCellRendererComponent: DateCellRendererComponent,
    skuCellRendererComponent: SkuCellRendererComponent,
  };
  gridOptions: GridOptions = {
    rowModelType: "serverSide",
    suppressServerSideInfiniteScroll: false,
    suppressCopyRowsToClipboard: true,
    cacheBlockSize: 100,
    defaultColDef: {
      resizable: true,
      sortable:false,
      filterParams: {
        maxNumConditions : 1,
      },
      menuTabs: ["filterMenuTab"],
    },
    components: this.components,
    rowSelection: "multiple",
    loadingCellRenderer: "loadingCellRenderer",
    onGridReady: (e) => {
      this.gridApi = e.api;
      this.headerService.accountsSelected.pipe(takeUntil(this.destroy$)).subscribe((e) => {
        this.gridApi.showLoadingOverlay();
        this.setGrid(this.columnDefs);
      });
    },
    onGridSizeChanged: (e) => this.resized(),
  };
  dataSource: IServerSideDatasource = {
    getRows: (params: any) => {
      if (this.asin) {
        const FullfillmentType = this._stockType == 'FBM' ? true : false
        this.planyardService
          .getOrdersHistByAsinFulfillment(
            params.request,
            this.columnDefs,
            {
              field: "Asin",
              filter: this.asin,
            },
            {
              field: "date",
              filter: this.firstStockDate,
            },
            this.account,
            FullfillmentType
          )
          .pipe(takeUntil(this.destroy$))
          .subscribe({
            next: (response: any) => {
              if (response) {
                if (!response.totalCount) {
                  this.gridApi.showNoRowsOverlay();
                } else {
                  this.gridApi.hideOverlay();
                }
                params.success({
                  rowData: response.data,
                  rowCount: response.totalCount,
                });
              }
            },
          error: (err) => {
          params.fail();
         }
       });
      }
    },
  };

  constructor(
    private planyardService: PlanyardService,
    private headerService: HeaderService,
    private humanizeDatePipe: HumanizeDatePipe
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (this.gridApi) {
      this.gridApi.refreshServerSide({ route: [], purge: true });
    }
  }

  ngOnInit(): void {}

  setGrid(columnDefs) {
    this.gridApi.setGridOption('columnDefs', columnDefs);
    this.gridApi.setGridOption("serverSideDatasource", this.dataSource);
    this.resized();
  }

  resized() {
    this.gridApi.sizeColumnsToFit();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
